import React from 'react';

import {Media, Product} from '../../../types';

import {View, StyleSheet, ImageBackground} from 'react-native';
import {TouchableOpacity} from 'react-native-gesture-handler';

import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  List,
  ActivityIndicator,
  useTheme,
  Divider,
  Text,
  Chip,
  IconButton,
  Menu,
} from 'react-native-paper';

import {useQuery} from 'react-query';

import {getFileStats, shareFileToWT} from '../../../api/media';
import {setSharing} from '../../../store/slices/fs';
import {useAuction} from '../../../hooks/useAuction';
import {findBy} from '../../../api';
import {MediaItemProps} from './mediaitem';
import {
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';
import {ShopStackParams} from '../../../types/nav';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
  },
  column: {
    flexDirection: 'column',
  },
  customTitle: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  additionalPadding: {
    paddingTop: 8,
  },
  image: {
    width: '100%',
    height: 'auto',
    opacity: 0.6,
    position: 'absolute',
    resizeMode: 'cover',
    zIndex: -1,
    flex: 1,
  },
});

export const ProductItem = (props: MediaItemProps & {i: Product}) => {
  const {
    i,
    itemLoading,
    width,
    onRemoveMediaPress,
    onDownloadMediaPress,
    isPlaying,
    onDragEnd,
    onDragStart,
    showMenu,
    hideMenu,
    onRemoveFile,
    onExportFile,
  } = props;
  const dispatch = useAppDispatch();
  const theme = useTheme();
  // const width = "100%"
  const navigation = useNavigation<NavigationProp<ShopStackParams>>();
  const thisItemIsLoading = i.id === itemLoading;

  const onCellPress = () =>
    navigation.navigate('Product', {
      productId: i.id,
      parentFolderId: i.folderId,
      title: i.title,
    });
  const onRemove = async () => onRemoveMediaPress(i);
  const isDownloading = useAppSelector(
    state => state.fs.downloadingProgress[i.id],
  );
  const isMenuOpen = useAppSelector(
    state => state.ui.folderItemMenuOpen === i.id,
  );
  const isSharing = useAppSelector(state => state.fs.sharing[i.id]);
  const isDownloadedQuery = useQuery(
    ['isDownloaded', i.id, i.isDownloaded],
    async () => {
      try {
        // let file = undefined
        const file = await getFileStats(i);
        // console.info('hasfile', file);
        if (file) {
          const onep = (i.size as number) / 100;
          const percent = parseFloat(
            (file.size / onep).toString(),
          ).toFixed(2);
          return percent;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
  const isDownloaded = isDownloadedQuery?.data;
  const onDownloadToggle = async () =>
    isDownloaded ? null : onDownloadMediaPress(i.id);
  const imageSource = {uri: i.thumbnail, cache: 'force-cache'};
  let iconName = isPlaying
    ? 'stop-circle-outline'
    : 'package-variant';

  let offlineTitle = isDownloaded
    ? 'Remove From Device'
    : 'Download To Device';

  let offlineIconName =
    isDownloadedQuery.isFetched && isDownloaded
      ? 'floppy'
      : 'cloud-download-outline';

  if (isDownloading) {
    offlineTitle = 'Downloading / Cancel';
  }
  let extractorIcon = i.extractor.toLowerCase();
  if (extractorIcon === 'wt') extractorIcon = 'folder-network';
  if (extractorIcon === 'local') extractorIcon = 'file';
  const height = 100;
  const cloudIcon =
    isDownloading !== undefined
      ? () => <ActivityIndicator animating={true} theme={theme} />
      : offlineIconName;
  const controlIconPaddingTop = 30;
  const touchableStyle = {
    pointerEvents: 'auto',
    paddingTop: controlIconPaddingTop,
  } as any;
  let downloadText = isDownloading
    ? `Downloading ${parseInt((isDownloading * 100).toString(), 10)}%`
    : 'Download';

  if (isDownloaded) downloadText = `Downloaded ${isDownloaded}%`;
  return (
    <View style={{width, height}}>
      <List.Item
        style={{height, zIndex: 2, position: 'absolute', width}}
        left={props => (
          <TouchableOpacity
            onPress={onCellPress}
            style={touchableStyle}>
            <List.Icon
              {...props}
              icon={
                thisItemIsLoading
                  ? () => (
                      <ActivityIndicator
                        animating={true}
                        theme={theme}
                      />
                    )
                  : iconName
              }
            />
          </TouchableOpacity>
        )}
        right={props => (
          <>
            <TouchableOpacity
              onPressIn={onDragStart}
              onPressOut={onDragEnd}
              style={{pointerEvents: 'auto'}}>
              <IconButton icon={'dots-grid'} />
            </TouchableOpacity>
            <Menu
              anchor={
                <IconButton
                  icon={'dots-vertical'}
                  onPress={showMenu}
                />
              }
              style={{marginTop: 50}}
              visible={isMenuOpen}
              onDismiss={hideMenu}>
              {isDownloaded && (
                <>
                  <Menu.Item
                    leadingIcon={'share'}
                    title={'Export File'}
                    onPress={onExportFile}
                  />
                  <Divider />
                </>
              )}
              {isDownloaded && (
                <>
                  <Menu.Item
                    leadingIcon={'file'}
                    title={'Delete File'}
                    onPress={onRemoveFile}
                  />
                  <Divider />
                </>
              )}
              <Menu.Item
                leadingIcon={'delete'}
                title={'Delete Item'}
                onPress={onRemove}
              />
            </Menu>
          </>
        )}
        title={({ellipsizeMode, color: titleColor, fontSize}) => (
          <View
            style={[
              styles.container,
              styles.row,
              styles.customTitle,
            ]}>
            <Text
              ellipsizeMode={ellipsizeMode}
              style={{color: titleColor, fontSize}}
              numberOfLines={2}>
              {i.title}
            </Text>
          </View>
        )}
        description={({
          ellipsizeMode,
          color: descriptionColor,
          fontSize,
        }) => (
          <View style={[styles.container, styles.column]}>
            <Text
              numberOfLines={1}
              ellipsizeMode={ellipsizeMode}
              style={{color: descriptionColor, fontSize}}>
              {i.description}
            </Text>
            <View
              style={[
                styles.container,
                styles.row,
                styles.additionalPadding,
                {gap: 10},
              ]}>
              <Chip
                icon={'file'}
                onPress={onDownloadToggle}
                style={{height: 30}}
                textStyle={{fontSize}}>
                {downloadText}
              </Chip>
              {isDownloaded && (
                <Chip
                  icon={isSharing ? 'heart' : 'network'}
                  onPress={() => {
                    if (isSharing) return;
                    dispatch(
                      setSharing({itemId: i.id, status: true}),
                    );
                    shareFileToWT(i.id, i.folderId);
                  }}
                  style={{height: 30}}
                  textStyle={{fontSize}}>
                  {isSharing ? 'Sharing' : 'Share'}
                </Chip>
              )}
            </View>
          </View>
        )}
      />
      {i.thumbnail ? (
        <ImageBackground
          source={{uri: i.thumbnail, cache: 'force-cache'}}
          resizeMethod="resize"
          resizeMode="cover"
          style={{
            ...styles.image,
            height,
            width,
          }}
          imageStyle={{...styles.image, height, width}}
        />
      ) : null}
      <Divider />
    </View>
  );
};
